import { errorServeiceHandler, makeQueryStringDync, makeQueryFormDataDyn } from "../helper";
const state = {
};
const getters = {
};
const mutations = {
};
const actions = {
	getInstantCustomerDetails: (context, filterData) => {
    let url = '/subscriber/v1/subscriber/instantpayment'
    return new Promise( (resolve, reject) => {
			let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve({"subscribername":"Neena Aidasani","email":"","mobileno":9987505831,"susbcriberstatus":"A","accountno":23397361,"region":"MUM","currentbalance":-223,"frcode":"DP0001","customertype":"DP","customeridentity":null})
          return
        }
        reject(error)
      });
    });
  },
  getQRCustomer: (context, filterData) => {
    let url = '/subscriber/v1/subscriber/qrcustomer'
    return new Promise( (resolve, reject) => {
			let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve({"subscribername":"Neena Aidasani","email":"","mobileno":9987505831,"susbcriberstatus":"A","accountno":23397361,"region":"MUM","currentbalance":-223,"frcode":"DP0001","customertype":"DP","customeridentity":null})
          return
        }
        reject(error)
      });
    });
  },
  getInstantPackDetails: (context, filterData) => {
    let url = '/subscriber/v1/subscriber/ldrprice'
    return new Promise( (resolve, reject) => {
			let queryStr = ''
			queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve({"basepacktariff":1,"monthlyprice":"351.94","quarterlyprice":"1055.82","halfyearlyprice":"1935.67","yearlyprice":"3871.34"})
          return
        }
        reject(error)
      });
    });
  },
  getOffersDetails: (context, filterData) => {
    let url = '/subscriber/v1/promo'
    return new Promise( (resolve, reject) => {
			let queryStr = ''
			queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        reject(error)
      });
    });
  }
};

export default {
  actions, state, getters, mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/instantPayment.js